export default (choices, length = 1) => {
  if (length !== 1) {
    return choices.sort(() => 0.5 - Math.random()).slice(0, length);
  } else {
    const index = Math.floor(Math.random() * choices.length);
    return choices[index];
  }
};
